<div class="container-fluid no-gutters">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="title">Upload Rating Guideline</h3>
  </div>
  <div class="mt-4">
    <h5>Upload Rating Guideline for Supplier</h5>
    <div class="row m-0 align-items-center">
      <input type="file" #file hidden (change)="onSelectFile($event,'external')">
      <button class="btn button btn-primary btn-width col-1" (click)="file.click()">Upload</button>
      <span class="col-6 pl-2 p-0">File Name: {{ supplierFileName }}</span>
      <button class="btn button btn-primary btn-width col-1" (click)="save('external')">Save</button>
    </div>
  </div>
  <div class="mt-5">
    <h5>Upload Rating Guideline for Internal</h5>
    <div class="row m-0 align-items-center">
      <input type="file" #file1 hidden accept=".pdf" (change)="onSelectFile($event,'internal')">
      <button class="btn button btn-primary btn-width col-1" (click)="file1.click()">Upload</button>
      <span class="col-6 pl-2 p-0">File Name: {{ internalFileName }}</span>
      <button class="btn button btn-primary btn-width col-1" (click)="save('internal')">Save</button>
    </div>
  </div>
</div>